var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"layout":_vm.layout ? _vm.layout : 'prev, pager, next, total',"total":_vm.total,"page-size":_vm.obj[_vm.attrSize],"current-page":_vm.obj[_vm.attrIndex],"page-sizes":_vm.attrSizes},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }